import { v4 as uuidv4 } from 'uuid';
const DEVICE_ID_KEY = 'did';
export const getDeviceId = () => {
    let did = localStorage.getItem(DEVICE_ID_KEY);
    if (!did) {
        did = uuidv4();
        localStorage.setItem(DEVICE_ID_KEY, did);
    }
    return did;
};
